module.exports = __webpack_public_path__ + "img/blis3.8392a58b.png";